import {
  ASSETS,
  REFERRAL_GIFT_VARIANT,
  ReferralGiftVariant
} from '../constants';
import type { ProductLayout, VariantConfig } from './referralHomeCardConfig';
import {
  Bottom,
  Cta,
  DesktopLayout,
  EuroSpotProduct,
  EuroTopEllipseWrap,
  Highlight,
  HunterSpotProduct,
  HunterSpotRoot,
  HunterTopEllipseWrap,
  IpadProductSpot,
  IpadSpotProduct,
  IpadSpotProductClip,
  IpadTopEllipseWrap,
  Product,
  ProductFrame,
  ProductRail,
  Ps5TopEllipseWrap,
  Subtitle,
  Title,
  Top,
  TopEllipseImage
} from './ReferralHomeCardDesktop.styles';

type ReferralHomeCardDesktopProps = {
  onClick: () => void;
  variant: ReferralGiftVariant;
  config: VariantConfig;
  productLayout: ProductLayout;
};

const ReferralHomeCardDesktop = ({
  onClick,
  variant,
  config,
  productLayout
}: ReferralHomeCardDesktopProps) => {
  const topEllipse = (
    <TopEllipseImage src={ASSETS.touchpointEllipse} alt="" aria-hidden />
  );

  return (
    <DesktopLayout>
      <Top>
        <Title>{config.title}</Title>
        <Highlight>{config.highlight}</Highlight>
        {variant === REFERRAL_GIFT_VARIANT.HUNTER ? (
          <HunterTopEllipseWrap>{topEllipse}</HunterTopEllipseWrap>
        ) : null}
        {variant === REFERRAL_GIFT_VARIANT.EURO_TRIP ? (
          <EuroTopEllipseWrap>{topEllipse}</EuroTopEllipseWrap>
        ) : null}
        {variant === REFERRAL_GIFT_VARIANT.IPAD ? (
          <IpadTopEllipseWrap>{topEllipse}</IpadTopEllipseWrap>
        ) : null}
        {variant === REFERRAL_GIFT_VARIANT.PS5 ? (
          <Ps5TopEllipseWrap>{topEllipse}</Ps5TopEllipseWrap>
        ) : null}
      </Top>
      <Bottom>
        <Subtitle>{config.subtitle}</Subtitle>
        <Cta type="button" onClick={onClick}>
          Refer & Win
        </Cta>
      </Bottom>
      {variant === REFERRAL_GIFT_VARIANT.IPAD ? (
        <IpadProductSpot>
          <IpadSpotProductClip>
            <IpadSpotProduct src={config.product} alt="" aria-hidden />
          </IpadSpotProductClip>
        </IpadProductSpot>
      ) : null}
      {variant === REFERRAL_GIFT_VARIANT.EURO_TRIP ? (
        <EuroSpotProduct src={config.product} alt="" aria-hidden />
      ) : null}
      {variant === REFERRAL_GIFT_VARIANT.HUNTER ? (
        <HunterSpotRoot>
          <HunterSpotProduct src={config.product} alt="" aria-hidden />
        </HunterSpotRoot>
      ) : null}
      {variant !== REFERRAL_GIFT_VARIANT.IPAD &&
      variant !== REFERRAL_GIFT_VARIANT.EURO_TRIP &&
      variant !== REFERRAL_GIFT_VARIANT.HUNTER ? (
        <ProductRail>
          <ProductFrame $top={productLayout.top}>
            <Product
              src={config.product}
              alt=""
              $width={productLayout.width}
              $height={productLayout.height}
              $objectPosition={config.objectPosition}
            />
          </ProductFrame>
        </ProductRail>
      ) : null}
    </DesktopLayout>
  );
};

export default ReferralHomeCardDesktop;
